import log from 'salvo-lite/log'
import axios from 'axios'
import { getUrlParams } from '../helpers/general'

class Clinics {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this._clinicsUrl = 'https://medichecks.eastsideapps.io/api/clinics'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.populateList(this.matchSearchQuery())
    }

    matchSearchQuery () {
        const searchQuery = getUrlParams()
        if (searchQuery.clinic_search) {
            return searchQuery.clinic_search.toLowerCase().replace(/\+/g, ' ')
        }
    }

    populateList () {
        const self = this
        let URLParams = getUrlParams()
        axios.get(this._clinicsUrl).then((response) => {
            const searchQuery = (URLParams.clinic_search) ? URLParams.clinic_search.toLowerCase().replace(/\+/g, ' ') : false

            const data = response.data
            let first = false
            // console.dir(data)
            for (var i = 0; i < Object.entries(data).length; i++) {
                let className = ''
                const clinic = Object.entries(data)[i][1]

                let filter = false
                if (searchQuery) {
                    filter = true
                    if (URLParams.clinic_id) {
                        filter = false
                    }
                }
                if (
                    !filter ||
                    (filter && (clinic.name.toLowerCase()).includes(searchQuery)) ||
                    (filter && (clinic.address.toLowerCase()).includes(searchQuery)) ||
                    (filter && (clinic.postcode.toLowerCase()).includes(searchQuery))
                ) {
                    const lat = `data-lat="${clinic.lat}" `
                    const lng = `data-lng="${clinic.lng}" `
                    const id = `data-id="${clinic.id}" `

                    if (URLParams.clinic_id) {
                        if (parseInt(URLParams.clinic_id) === clinic.id) {
                            className = ' selected'
                        }
                    } else {
                        if (!first) {
                            className = ' selected'
                        }
                    }

                    const newClinicListItem = document.createElement('div')
                    newClinicListItem.innerHTML = `
                    <a href="?clinic_search=${clinic.name.toLowerCase().replace(/ /g, '+')}&clinic_id=${clinic.id}" ${lat}${lng}${id}class="clinics-list-item ${className}">
                        <h2 class="clinics-list-item__title">${clinic.name}</h2>
                        <p class="clinics-list-item__address">${clinic.address}, ${clinic.postcode}</p>
                    </a>
                    `
                    self._elem.appendChild(newClinicListItem)
                    first = true
                }
            }
            if (URLParams.clinic_id) {
                self._elem.prepend(document.querySelector(`[data-id="${URLParams.clinic_id}"]`))
            }
            this.theme.registerComponents(self._elem)
        }).catch(function (error) {
            console.error(error)
        })
    }
}

export default Clinics



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Clinics.js